export const SPECIAL_OFFER_1 = "specialOffer1";

export const SPECIAL_OFFERS = "specialOffers";
